import {debounce} from 'lodash';

require("./../plugins/jquery.lettering");
require('waypoints/lib/noframework.waypoints.js');

$(function () {
    $('.page-hero .slide-button').click(function (e) {
        e.preventDefault();
        const body = $("html, body");
        body.stop().animate(
            {scrollTop: window.innerHeight},
            500,
            'swing'
        );
    });

    var waypoint = new Waypoint({
        element: $('.page-hero')[0],
        handler: function(direction) {
            // alert('I am 600 from the top of the window');
            $('.page-hero .slide-button').addClass('hide')
        },
        offset: -400
    })

    playVideo();

    function playVideo() {
        const $el = $('.page-hero');
        if(window.innerWidth >= 768){
            $el.find('.desktop video')[0].play();
            // $el.find('.desktop video').attr('autoplay', '');
        } else {
            $el.find('.mobile video')[0].play();
            // $el.find('.mobile video').attr('autoplay', '');
        }
    }

    $(window).on('resize', _.debounce(function() {
        playVideo();
    }, 100));
});